<template>
  <GmapCustomMarker :key="`point-marker-${id}`" :marker="marker" @click.native="$emit('click')">
      <div class="point-marker" :class="{ active }">
      <img alt="point-marker" src="@/assets/images/point/marker-no-shadow.svg" />

      <div class="point-marker__container" :style="{ backgroundColor: color }">
        <span v-if="icon === 'DEFAULT'">
          {{ number }}
        </span>
        <i v-else-if="icon === 'START'" class="icon-fill_home" />
        <i v-else-if="icon === 'END'" class="icon-fill_flag" />
        <div v-else-if="icon === 'MARKER'" class="__marker" />
      </div>
      <p v-if="showLabel" class="point-marker__label">
        {{ address }}
      </p>
    </div>
  </GmapCustomMarker>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker'

export default {
  components: {
    GmapCustomMarker,
  },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    number: {
      type: Number,
      default: null,
    },
    icon: {
      type: String,
      default: 'DEFAULT',
    },
    marker: {
      type: Object,
      default: () => {},
    },
    color: {
      type: String,
      default: '#1c74da',
    },
    active: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    address: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss" scoped>
.point-marker {
  position: relative;
  text-align: center;
  cursor: pointer;

  &__label {
    margin-bottom: 0;
    padding: 8px;
    background-color: white;
    width: 175px;
    color: black;
    font-size: 12px;
    position: absolute;
    bottom: -32px;
    left: 50%;
    transform: translateX(-50%);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    box-shadow: 0px 4px 8px 0px #10184029;
  }

  img {
    width: 100%;
  }

  &.active {
    &:before {
      content: '';
      width: 50px;
      height: 50px;
      background-color: rgba(1, 19, 61, 0.4);
      border-radius: 100%;
      display: block;
      position: absolute;
      left: -5px;
      margin: 0 auto;
      top: 55px;
      transform: translateY(-50%);
      animation: carico 1.2s infinite;
      transition: 0.3s;
    }

    &:after {
      content: '';
      width: 70px;
      height: 70px;
      background-color: rgba(1, 19, 61, 0.25);
      border-radius: 100%;
      display: block;
      position: absolute;
      left: -15px;
      right: 0;
      margin: 0 auto;
      top: 95%;
      transform: translateY(-50%);
      animation: carico 1.2s infinite;
      transition: 0.3s;
    }
  }

  &__container {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
    color: $white;
    font-size: 16px;

    span,
    i,
    .__marker {
      position: absolute;
      top: 8px;
      left: 0;
      right: 0;
      margin: 0 auto;
      font-weight: 600;
    }

    i:before {
      color: $white;
    }

    .__marker {
      width: 16px;
      height: 16px;
      border-radius: 100%;
      background-color: $white;
      top: 9px;
    }
  }

}
</style>
